import type { RouteRecordRaw } from 'vue-router';

import { computed } from 'vue';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'inbox',
    children: [
      {
        name: 'inbox',
        path: '',
        component: () => import('../InboxIndex.vue'),
        meta: {
          title: computed(() => t('messages.notification', 2)),
        },
      },
      {
        name: 'inbox-item',
        path: ':uuid',
        props: true,
        component: () => import('../InboxItem.vue'),
        meta: {
          title: computed(() => t('messages.notification', 2)),
        },
      },
    ],
  },

];
